'use client'
import { type Locale } from '@/i18n/config'
import { useEffect, useRef, useState, type FC } from 'react'

interface ExplainerEmbedProps {
  title: string
  lang: Locale
}

const ExplainerEmbed: FC<ExplainerEmbedProps> = ({ title, lang }) => {
  const frameRef = useRef<HTMLIFrameElement>(null)
  const [height, setHeight] = useState<number | null>(null)

  const requestHeight = () => frameRef.current?.contentWindow?.postMessage({ type: 'opsynk-explainer:request-height' }, window.location.origin)

  useEffect(() => {
    const onMessage = (event: MessageEvent) => {
      if (event.source !== frameRef.current?.contentWindow) return
      if (event.data?.type !== 'opsynk-explainer:height' || typeof event.data.height !== 'number') return
      setHeight(event.data.height)
    }
    window.addEventListener('message', onMessage)
    requestHeight()
    return () => window.removeEventListener('message', onMessage)
  }, [])

  return (
    <div
      className="mx-auto w-full overflow-hidden rounded-2xl bg-[#070E1E] shadow-[0_24px_48px_-24px_rgba(7,14,30,0.5)]"
      style={{ maxWidth: 'min(56rem, calc((100vh - 200px) * 16 / 9))' }}
    >
      <iframe
        ref={frameRef}
        src={`/how-opsynk-works.html?embed=1&lang=${lang}`}
        title={title}
        loading="lazy"
        allow="fullscreen"
        allowFullScreen
        scrolling="no"
        onLoad={requestHeight}
        className="block w-full border-0"
        style={height ? { height } : { aspectRatio: '16 / 10' }}
      />
    </div>
  )
}

export default ExplainerEmbed
